import { render, staticRenderFns } from "./pcFocusManage.vue?vue&type=template&id=0326e868&"
import script from "./pcFocusManage.vue?vue&type=script&lang=js&"
export * from "./pcFocusManage.vue?vue&type=script&lang=js&"
import style0 from "./pcFocusManage.vue?vue&type=style&index=0&id=0326e868&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports